import React from "react";

/**
 * Persistent record header (V3 §8) — appears above a project/estimate/contract
 * detail page and stays visible as the user tabs through nested views.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.title
 * @param {React.ReactNode} [props.meta]
 * @param {React.ReactNode} [props.actions]
 */
export function RecordHeader({ title, meta, actions }) {
  return (
    <div className="ds-record-header">
      <div>
        <div className="ds-record-header-title">{title}</div>
        {meta && <div className="ds-record-header-meta">{meta}</div>}
      </div>
      <div />
      <div>{actions}</div>
    </div>
  );
}

/**
 * Contextual tabs rendered right below the RecordHeader.
 * Same underline-tab visual language as the base `Tabs` primitive.
 */
export function ContextualTabs({ value, onChange, items = [] }) {
  return (
    <div className="ds-contextual-tabs" role="tablist">
      {items.map((t) => (
        <button
          key={t.value}
          role="tab"
          aria-selected={value === t.value}
          className={`ds-comp-tab ${value === t.value ? "is-active" : ""}`.trim()}
          onClick={() => onChange(t.value)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
